module.exports = __webpack_public_path__ + "media/images/row3_img2-3f5085497f3379d36d4b789b78a6c24c.jpg";